import { Typography } from "@mui/material";
import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LabelColumnV2 } from "../../components/DataGridV2/DataColumnsV2";

export const getWbEmailLinkListColumns = ({ t,
  keyPrefix,
  i18n,
  apiRef,
  setAnchorEl,
  setSelectedEmailId,
  setOldEmailId
}) => {
  const getOptions = getGridContextMenuList({
    filterKey: LOCAL_STORAGE_GRID_KEYS.WB_EMAIL_LINK_LIST_COLUMN_FILTER[keyPrefix],
    sortKey: LOCAL_STORAGE_GRID_KEYS.WB_EMAIL_LINK_LIST_COLUMN_SORT[keyPrefix],
    i18n,
    t,
    apiRef,
    mode: "client",
  })

  return [
    {
      download: true,
      print: true,
      field: "email",
      headerName: t("general.email"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.email}
            cellSubMenuOptions={{ options: getOptions({ field: "email", isQuickFilterDisplay: Boolean(rowData.email) }), extraData: { fieldName: "email" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "loginPersonName",
      headerName: t("settings.table.column.personName"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.loginPersonName}
            cellSubMenuOptions={{ options: getOptions({ field: "loginPersonName", isQuickFilterDisplay: Boolean(rowData.loginPersonName) }), extraData: { fieldName: "loginPersonName" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "loginEmail",
      headerName: t("settings.table.column.personEmail"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.loginEmail}
            cellSubMenuOptions={{ options: getOptions({ field: "loginEmail", isQuickFilterDisplay: Boolean(rowData.loginEmail) }), extraData: { fieldName: "loginEmail" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "edit",
      headerName: t("general.action"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={
              <Typography
                variant="caption"
                onClick={(e) => {
                  e.stopPropagation()
                  setAnchorEl(e.currentTarget);
                  setSelectedEmailId(rowData?.email);
                  setOldEmailId(rowData?.loginId);
                }}
                sx={{
                  color: "primary.main",
                }}
              >
                {t("general.edit")}
              </Typography>
            }
            request={rowData}
          />
        );
      },
    },
  ];
}


